__turbopack_context__.v({
  "bg-gradient-black": "background-colors-module__aCyCDa__bg-gradient-black",
  "bg-gradient-dark-grey": "background-colors-module__aCyCDa__bg-gradient-dark-grey",
  "bg-gradient-light": "background-colors-module__aCyCDa__bg-gradient-light",
  "bg-gradient-light-grey": "background-colors-module__aCyCDa__bg-gradient-light-grey",
  "bg-gradient-light-invert": "background-colors-module__aCyCDa__bg-gradient-light-invert",
});
